// extracted by mini-css-extract-plugin
module.exports = {"socialMediaButtons":"style-module--socialMediaButtons--1eOjP"};